import { DialogProps } from '@fortem-monorepo/react-ui'
import { SubmitButton } from '@fortem-monorepo/react-ui'
import { Button } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { RunScenarioForm } from '@/components/forms/pricing-interface/RunScenarioForm/RunScenarioForm'
import { RunScenarioFormFields } from '@/components/forms/pricing-interface/RunScenarioForm/RunScenarioFormFields'

export interface RunScenarioModalProps extends DialogProps {}

export const RunScenarioModal: React.FC<RunScenarioModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <RunScenarioForm
          defaultValues={{ input_type: 'default_scenario', instance_tag: 'LOCALINST1' }}
        >
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Run Scenario</DialogTitle>
                </DialogHeader>
                <div className="my-6">
                  <RunScenarioFormFields />
                </div>
                <DialogFooter>
                  <Button
                    type="button"
                    variant={'destructive'}
                    size="sm"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </RunScenarioForm>
      </DialogContent>
    </Dialog>
  )
}
